import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController, IonInput, LoadingController } from '@ionic/angular';
import { CartService } from '../../services/cart.service';
import { Decimal } from 'decimal.js';
import { StorageService } from 'src/app/services/storage.service';
import { APIService } from 'src/app/services/api.service';
import { PusherService } from 'src/app/services/pusher.service';
import { Subscription } from 'rxjs';
import { SmartpayReaderService } from 'src/app/services/smartpay-reader.service';

@Component({
    selector: 'app-checkout-payment-smartpay',
    templateUrl: './checkout-payment-smartpay.page.html',
    styleUrls: ['./checkout-payment-smartpay.page.scss'],
})
export class CheckoutPaymentSmartpayCardPage implements OnInit {
    
    private subscription!: Subscription;

    cart = null;
    payment_amount = null;

    payment = {
        price: null,
        payment_service_id: '37CF49B6-9D0E-A6BE-BF18B291CAB60B65' // smartpay
    };
    
    current_register_id = null;
    processing_charge = false;
    processing_charge_timestamp = 0;

    polling_interval_id = null;
    current_transaction_id = null;

    show_possibly_offline = false;
    transaction_subscription: Subscription;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cartService: CartService,
        public loadingController: LoadingController,
        private storageService: StorageService,
        private smartpayReaderService: SmartpayReaderService
    ) { }

    ngOnInit() {

        this.cartService.get().then((cart) => {
            if (cart) {
                this.cart = cart;
                this.payment.price = cart['amount_due'];
                this.payment_amount = cart['amount_due'].toFixed(2);
            }
        });

        this.storageService.get('register_id').then((current_register_id) => {
            this.current_register_id = current_register_id;
        });

        this.transaction_subscription = this.smartpayReaderService.transactionObservable.subscribe(payment_status => {

            if(payment_status.transaction_id == this.current_transaction_id && this.processing_charge) {

                if(payment_status.status == "success" && 'payment' in payment_status) {
                    this.payment.price = payment_status.payment.price;
                    this.payment['payment_service_transaction_id'] = payment_status.payment.payment_service_transaction_id;
                    this.payment['payment_service_receipt_text'] = payment_status.payment.payment_service_receipt_text;
                    this.payment['method'] = payment_status.payment.method;
                    this.payment['label'] = payment_status.payment.label;
                    if('surcharge_rate' in payment_status.payment && payment_status.payment.surcharge_rate > 0) {
                        this.payment['surcharge_rate'] = payment_status.payment.surcharge_rate;
                    }
                    this.addPayment();
                } 
                else if(payment_status.status == "declined") {
                    this.presentAlert("Problem", "", "Payment declined");
                } 
                else if(payment_status.status == "failed") {
                    this.presentAlert("Problem", "", "Failed to charge card");
                } 
                else if(payment_status.status == "offline") {
                    this.presentAlert("Problem", "", "Smartpay reader is offline");
                } 
                else if(payment_status.status == "delayed") {
                    this.show_possibly_offline = true;
                } 
                else if(payment_status.status == "cancelled") {
                    this.presentAlert("Problem", "", "Payment cancelled");
                } 
                else if(payment_status.status == "service_unavailable") {
                    this.presentAlert("Problem", "", "Service unavailable");
                }

                if(payment_status.status != "delayed") {
                    this.show_possibly_offline = false;
                    this.processing_charge = false;
                    this.current_transaction_id = null;
                }
            }
        });
    }

    ngOnDestroy() {
        clearInterval(this.polling_interval_id);
    }

    sanitisePaymentAmount() {

        let payment_amount = this.payment_amount.toString();
        
        // only accept numbers/decimal points
        if(/[^0-9.]/.test(payment_amount)) {
            this.payment.price = null;
        }        
        else if(payment_amount.startsWith('.')) {
            this.payment.price = null;
        }
        else if(payment_amount.endsWith('.')) {
            this.payment.price = null;
        }              
        else if(payment_amount.split('.').length > 2) {
            this.payment.price = null;
        }
        else if(!payment_amount.length) {
            this.payment.price = null;
        }
        else {
            this.payment.price = Number(new Decimal(payment_amount).toDecimalPlaces(2));
        }

    }        

    async chargeCard() {
        
        // ensure payment isn't over the amount due
        if(this.payment.price > this.cart.amount_due) {
            this.payment.price = this.cart.amount_due;
        }

        this.processing_charge = true;
        
        this.smartpayReaderService.chargeCard(Number(new Decimal(this.payment.price).times(100).toDecimalPlaces(2))).then((transaction_id) => {
            this.processing_charge_timestamp = Date.now();
            this.current_transaction_id = transaction_id;
        }).catch((error) => {   
            this.processing_charge = false;
            if(error == "register_not_paired") {
                this.presentAlert("Problem", "", "The POS has been unpaired from the Smartpay reader. Cannot process payment");
                this.modalController.dismiss("unpaired");
            } 
            else if(error == "reader_busy") {
                this.presentAlert("Problem", "", "The Smartpay reader is already processing a transaction");
            } 
            else if(error == "service_unavailable") {
                this.presentAlert("Problem", "", "Service unavailable");
            }
        });
    }

    addPayment() {
        this.cartService.addPayment(this.payment).then(() => {
            this.close();
        });
    }

    close() {
        if(this.processing_charge) {
            // 60 seconds until cancellable
            if(Date.now() - this.processing_charge_timestamp < 60_000) {
                this.presentAlert("Problem", "", "Please cancel transaction on the Smartpay reader.");
            } else {
                this.processing_charge = false;
                this.smartpayReaderService.clearCurrentTransaction();
                this.transaction_subscription.unsubscribe();
                // Data passed so parent canDismiss will allow dismiss
                this.modalController.dismiss({ timeout: true });
            }
        } else {
            this.transaction_subscription.unsubscribe();
            this.modalController.dismiss();
        }
    }

    async presentAlert(header, sub_header, message) {
		const alert = await this.alertController.create({
			header: header,
			subHeader: sub_header,
			message: message,
			buttons: ["OK"],
		});
		await alert.present();
	}
}
